import { render, staticRenderFns } from "./insuranceTypeDialog.vue?vue&type=template&id=634d3988"
import script from "./insuranceTypeDialog.vue?vue&type=script&lang=js"
export * from "./insuranceTypeDialog.vue?vue&type=script&lang=js"
import style0 from "./insuranceTypeDialog.vue?vue&type=style&index=0&id=634d3988&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports